// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { useSelector } from "react-redux";

export const useProductWarrantyLookup = () =>
    useSelector((state: ApplicationState) => state.store.pages.productWarranty);
